import React, { useEffect } from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer'
import Members from '../Components/Members'


const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div>
        <Navbar />
      <div className="pt-24">
        {" "}
        <Members />{" "}
      </div>
        <Footer />
    </div>
  )
}

export default AboutUs
